import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import mammoth from 'mammoth';

function App() {
  // 登录系统相关状态
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loginUsername, setLoginUsername] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [registerUsername, setRegisterUsername] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');
  const [authError, setAuthError] = useState('');
  const [showLoginForm, setShowLoginForm] = useState(true);
  const [showAuthModal, setShowAuthModal] = useState(false);

  // 原有功能状态
  const [activePage, setActivePage] = useState('home');
  const [selectedFile, setSelectedFile] = useState(null);
  const [files, setFiles] = useState([]);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [filesToUpload, setFilesToUpload] = useState([]);
  const fileInputRef = useRef(null);
  // 新增状态用于管理部署设置
  const [deploymentMethod, setDeploymentMethod] = useState('');
  const [modelType, setModelType] = useState('');
  const [role, setRole] = useState('');
  const [associatedFiles, setAssociatedFiles] = useState('');
  // 新增状态用于API管理
  const [apis, setApis] = useState([]);
  const [showFileDropdown, setShowFileDropdown] = useState(false);
  // 新增状态用于对话历史
  const [conversation, setConversation] = useState([]);
    // AppID绑定状态
  const [appid, setAppid] = useState('');
  // 新增状态用于打字机效果
  const [displayedAnswer, setDisplayedAnswer] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [currentAnswerIndex, setCurrentAnswerIndex] = useState(-1);
  // 对话容器的引用，用于自动滚动到底部
  const conversationContainerRef = useRef(null);
    // 微信公众号配置状态
  const [wechatAppId, setWechatAppId] = useState('');
  const [wechatAppSecret, setWechatAppSecret] = useState('');

    // 显示充值弹窗
  const showRechargeModal = () => {
    // 这里可以实现跳转到充值界面的逻辑
    // 目前先用alert提示功能开发中
    alert('即将跳转到充值界面');
    // 未来可以使用window.location.href跳转到实际的充值页面
  };

  // 添加清除对话历史的函数
  const handleClearConversation = () => {
    // 确认用户是否真的要清除
    if (window.confirm('确定要清除所有对话历史吗？此操作不可恢复。')) {
      setConversation([]);
      setDisplayedAnswer('');
      setIsTyping(false);
      setCurrentAnswerIndex(-1);
      // 清除localStorage中的对话历史
      localStorage.removeItem('chatConversation');
    }
  };

  // 自动滚动到底部的函数
  const scrollToBottom = () => {
    if (conversationContainerRef.current) {
      conversationContainerRef.current.style.scrollBehavior = 'smooth';
      conversationContainerRef.current.scrollTop = conversationContainerRef.current.scrollHeight;
    }
  };

  // 当对话内容或显示的回答变化时，自动滚动到底部
  
  useEffect(() => {
  const timer = setTimeout(() => {
    scrollToBottom();
  },80); // 延迟 0 毫秒，让 DOM 完全渲染

  // 清理定时器
  return () => clearTimeout(timer);
}, []);
  useEffect(() => {
    scrollToBottom();
  }, [conversation, displayedAnswer]);
  
    // 处理AppID绑定
  const handleBindAppid = async () => {
    const inputAppid = prompt('请输入要绑定的原始ID：');
    if (!inputAppid) return;
    
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('请先登录');
        return;
      }
      
      const response = await fetch('https://www.orient.icu/backend/users/update-appid', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          appid: inputAppid
        })
      });
      
      const result = await response.json();
      
      if (response.ok) {
        setAppid(inputAppid);
        alert(result.message || '原始ID绑定成功！');
      } else {
        alert('绑定失败：' + (result.detail || '请稍后重试'));
      }
    } catch (error) {
      console.error('绑定原始ID时发生错误:', error);
      alert('网络错误，请检查连接后重试');
    }
  };


// 处理密码修改
  const handleChangePassword = async () => {
    const currentPassword = prompt('请输入当前密码：');
    if (!currentPassword) return;
    
    const newPassword = prompt('请输入新密码（至少6位）：');
    if (!newPassword || newPassword.length < 6) {
      alert('新密码长度至少为6位');
      return;
    }
    
    const confirmPassword = prompt('请再次输入新密码：');
    if (newPassword !== confirmPassword) {
      alert('两次输入的新密码不一致');
      return;
    }
    
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('https://www.orient.icu/backend/users/change-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          current_password: currentPassword,
          new_password: newPassword
        })
      });
      
      const result = await response.json();
      
      if (response.ok) {
        alert(result.message || '密码修改成功！');
      } else {
        alert('修改密码失败：' + (result.detail || '请稍后重试'));
      }
    } catch (error) {
      console.error('修改密码时发生错误:', error);
      alert('网络错误，请检查连接后重试');
    }
  };

  // 检查本地存储中的令牌，自动登录
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      checkUserAuthentication(token);
    }
  }, []);

  // 从localStorage加载部署代码
  useEffect(() => {
    const savedApis = localStorage.getItem('deployments');
    if (savedApis) {
      try {
        setApis(JSON.parse(savedApis));
      } catch (error) {
        console.error('解析本地存储的部署代码失败:', error);
      }
    }
  }, []);

  // 从localStorage加载对话历史
  useEffect(() => {
    const savedConversation = localStorage.getItem('chatConversation');
    if (savedConversation) {
      try {
        setConversation(JSON.parse(savedConversation));
      } catch (error) {
        console.error('解析本地存储的对话历史失败:', error);
      }
    }
  }, []);

  // 点击外部区域关闭下拉菜单
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showFileDropdown && !event.target.closest('.file-selector-container')) {
        setShowFileDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFileDropdown]);

  // 当用户登录状态变化时，从服务器加载文件列表
  useEffect(() => {
    if (isLoggedIn) {
      loadFilesFromServer();
    } else {
      // 用户未登录时，从localStorage加载文件（保持原有功能）
      const savedFiles = localStorage.getItem('chatFiles');
      if (savedFiles) {
        try {
          const parsedFiles = JSON.parse(savedFiles);
          setFiles(parsedFiles.map(file => ({
            ...file,
            size: formatFileSize(new Blob([file.content]).size),
            uploadedAt: new Date().toLocaleString('zh-CN')
          })));
        } catch (error) {
          console.error('解析本地存储的文件失败:', error);
        }
      }
    }
  }, [isLoggedIn]);

  // 从服务器加载文件列表
  const loadFilesFromServer = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      
      const response = await fetch('https://www.orient.icu/backend/files/list', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        const serverFiles = data.files || [];
        
        // 转换文件数据格式以匹配前端需求
        const formattedFiles = serverFiles.map(file => ({
          id: file.filename + Date.now(), // 使用文件名+时间戳作为唯一ID
          name: file.filename,
          size: formatFileSize(file.size),
          uploadedAt: new Date(file.upload_time).toLocaleString('zh-CN'),
          // 注意：这里无法直接从服务器获取文件内容，只获取元数据
          content: ''
        }));
        
        setFiles(formattedFiles);
        
        // 同时更新localStorage
        localStorage.setItem('chatFiles', JSON.stringify(formattedFiles.map(file => ({
          id: file.id,
          name: file.name,
          content: file.content
        }))));
      } else {
        console.error('获取文件列表失败');
      }
    } catch (error) {
      console.error('加载文件列表时发生错误:', error);
    }
  };

  // 检查用户认证状态
  const checkUserAuthentication = async (token) => {
    try {
      const response = await fetch('https://www.orient.icu/backend/users/me', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const userData = await response.json();
        setIsLoggedIn(true);
        setCurrentUser(userData);
        setAppid(userData.appid || '');
        setAuthError('');
      } else {
        localStorage.removeItem('token');
        setIsLoggedIn(false);
        setCurrentUser(null);
      }
    } catch (err) {
      console.error('验证用户失败:', err);
      localStorage.removeItem('token');
      setIsLoggedIn(false);
      setCurrentUser(null);
    }
  };

  // 用户注册功能
  const handleRegister = async (e) => {
    e.preventDefault();
    setAuthError('');
    setIsLoading(true);

    // 添加用户名非空验证
    if (!registerUsername || registerUsername.trim() === '') {
      setAuthError('用户名不能为空');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch('https://www.orient.icu/backend/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: registerUsername,
          password: registerPassword
        })
      });

      if (response.ok) {
        // 注册成功后显示美化的提示
        showSuccessNotification('注册成功！欢迎加入我们的平台');
        // 清空输入框
        setRegisterUsername('');
        setRegisterPassword('');
        // 切换到登录表单
        setShowLoginForm(true);
      } else {
        const errorData = await response.json();
        // 优化错误提示
        if (errorData.detail) {
          if (typeof errorData.detail === 'string') {
            // 美化用户名已被注册的错误提示
            if (errorData.detail.includes('用户名已被注册')) {
              setAuthError('该用户名已被使用，请选择其他用户名');
            } else {
              setAuthError(errorData.detail);
            }
          } else if (errorData.detail.username) {
            setAuthError(errorData.detail.username[0]);
          } else if (errorData.detail.password) {
            // 美化密码相关的错误提示
            if (errorData.detail.password[0].includes('at least 6 characters')) {
              setAuthError('密码长度至少需要6个字符');
            } else {
              setAuthError(errorData.detail.password[0]);
            }
          } else if (Array.isArray(errorData.detail)) {
            // 处理数组形式的错误信息
            const firstError = errorData.detail[0];
            if (firstError.loc && firstError.loc.includes('password') && 
                firstError.msg && firstError.msg.includes('at least 6 characters')) {
              setAuthError('密码长度至少需要6个字符');
            } else {
              setAuthError(JSON.stringify(errorData.detail) || '注册失败，请重试');
            }
          } else {
            setAuthError(JSON.stringify(errorData.detail) || '注册失败，请重试');
          }
        } else {
          setAuthError('注册失败，请重试');
        }
      }
    } catch (err) {
      console.error('注册出错:', err);
      setAuthError('注册失败，请检查网络连接');
    } finally {
      setIsLoading(false);
    }
  };

  // 美化的成功提示通知函数
  const showSuccessNotification = (message) => {
    // 创建提示元素
    const notification = document.createElement('div');
    notification.className = 'success-notification';
    notification.innerHTML = `
      <div class="notification-content">
        <div class="notification-icon">✓</div>
        <div class="notification-text">${message}</div>
      </div>
    `;
    
    // 获取密码输入框的父元素
    const passwordField = document.getElementById('registerPassword');
    if (passwordField) {
      const formGroup = passwordField.closest('.form-group');
      if (formGroup && formGroup.nextElementSibling) {
        // 插入到密码输入框和错误信息/按钮之间
        formGroup.parentNode.insertBefore(notification, formGroup.nextElementSibling);
      }
    } else {
      // 如果找不到密码框，默认添加到文档中
      document.body.appendChild(notification);
    }
    
    // 添加显示动画
    setTimeout(() => {
      notification.style.opacity = '1';
      notification.style.transform = 'translateY(0)';
    }, 10);
    
    // 3秒后自动消失
    setTimeout(() => {
      notification.style.opacity = '0';
      notification.style.transform = 'translateY(-20px)';
      notification.style.height = '0';
      notification.style.margin = '0';
      notification.style.padding = '0';
      notification.style.overflow = 'hidden';
      
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 3000);
  };

  // 用户登录功能
  const handleLogin = async (e) => {
    e.preventDefault();
    setAuthError('');
    setIsLoading(true);

    try {
      const response = await fetch('https://www.orient.icu/backend/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          'username': loginUsername,
          'password': loginPassword,
          'grant_type': 'password'
        })
      });

      if (response.ok) {
        const data = await response.json();
        const token = data.access_token;
        localStorage.setItem('token', token);
        await checkUserAuthentication(token);
        setShowAuthModal(false);
      } else {
        const errorData = await response.json();
        setAuthError(typeof errorData.detail === 'string' ? errorData.detail : JSON.stringify(errorData.detail) || '登录失败，请检查用户名和密码');
      }
    } catch (err) {
      console.error('登录出错:', err);
      setAuthError('登录失败，请检查网络连接');
    } finally {
      setIsLoading(false);
    }
  };

  // 用户登出功能
  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setCurrentUser(null);
  };

  useEffect(() => {
    // 在实际应用中，这里应该是从API获取数据
    setFiles([]); // 初始为空，不显示默认的测试文档
  }, []);

  const handleFileSelect = (event) => {
    const selectedFiles = Array.from(event.target.files);
    
    // 验证文件格式，只接受txt和docx
    const validFiles = selectedFiles.filter(file => 
      file.name.endsWith('.txt') || file.name.endsWith('.docx')
    );
    
    if (validFiles.length > 0) {
      setFilesToUpload(validFiles);
      setError('');
      
      // 如果有不符合要求的文件，显示提示
      if (validFiles.length < selectedFiles.length) {
        setError('仅支持TXT和DOCX格式的文件上传');
      }
      
      // 重置文件输入，以便可以选择同一个文件
      event.target.value = '';
    } else {
      setError('请选择TXT或DOCX格式的文件');
      // 重置文件输入，以便可以选择同一个文件
      event.target.value = '';
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleConfirmUpload = async () => {
    if (filesToUpload.length === 0) {
      setError('请先选择要上传的文件');
      return;
    }

    setIsLoading(true);
    setError('');
    
    try {
      // 获取认证令牌
      const token = localStorage.getItem('token');
      if (!token) {
        setError('请先登录后再上传文件');
        setIsLoading(false);
        return;
      }
      
      const uploadedFiles = [];
      
      // 逐个上传文件到服务器
      for (const file of filesToUpload) {
        const formData = new FormData();
        formData.append('file', file);
        
        const response = await fetch('https://www.orient.icu/backend/files/upload', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formData
        });
        
        if (!response.ok) {
          throw new Error(`文件上传失败: ${file.name}`);
        }
        
        const fileData = await response.json();
        uploadedFiles.push({
          id: fileData.file.filename + Date.now(), // 使用文件名+时间戳作为唯一ID
          name: fileData.file.filename,
          size: formatFileSize(fileData.file.size),
          uploadedAt: new Date().toLocaleString('zh-CN'),
          content: await readFileContent(file) // 仍然保存文件内容用于前端显示
        });
      }
      
      // 检查并移除已存在的同名文件
      const existingFiles = files.filter(file => 
        !uploadedFiles.some(newFile => newFile.name === file.name)
      );
      
      // 更新文件列表
      const updatedFiles = [...uploadedFiles, ...existingFiles];
      setFiles(updatedFiles);
      
      // 将文件内容存储到localStorage，以便嵌入的聊天窗口访问
      localStorage.setItem('chatFiles', JSON.stringify(updatedFiles.map(file => ({
        id: file.id,
        name: file.name,
        content: file.content
      }))));
      
      // 选择第一个新上传的文件
      if (uploadedFiles.length > 0) {
        setSelectedFile(uploadedFiles[0]);
      }
      
      // 如果这是第一批上传的文件，自动关联第一个
      if (files.length === 0 && uploadedFiles.length > 0) {
        setAssociatedFiles(uploadedFiles[0].name);
      }
      
      // 清除待上传文件
      setFilesToUpload([]);
    } catch (err) {
      console.error('文件上传错误:', err);
      setError('文件上传失败，请重试');
    } finally {
      setIsLoading(false);
    }
  };

  // 读取文件内容的辅助函数
  const readFileContent = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      // 中文繁简转换函数 - 使用简单的映射表进行常见词汇的转换
      const convertToSimplified = (text) => {
        // 常见的繁简转换映射表
        const traditionalToSimplified = {
          '廣': '广', '場': '场', '發': '发', '達': '达', '會': '会',
          '學': '学', '國': '国', '語': '语', '電': '电', '腦': '脑',
          '風': '风', '雲': '云', '飛': '飞', '馬': '马', '車': '车',
          '東': '东', '南': '南', '西': '西', '北': '北', '門': '门',
          '個': '个', '眾': '众', '從': '从', '萬': '万', '餘': '余',
          '後': '后', '爾': '尔', '華': '华', '臺': '台', '灣': '湾',
          '亞': '亚', '衛': '卫', '為': '为', '備': '备', '產': '产',
          '長': '长', '稱': '称', '處': '处', '帶': '带', '黨': '党',
          '導': '导', '燈': '灯', '鄧': '邓', '敵': '敌', '點': '点',
          '獨': '独', '斷': '断', '對': '对', '兒': '儿', '爾': '尔',
          '發': '发', '豐': '丰', '風': '风', '婦': '妇', '復': '复',
          '蓋': '盖', '幹': '干', '趕': '赶', '個': '个', '給': '给',
          '觀': '观', '廣': '广', '歸': '归', '國': '国', '過': '过',
          '漢': '汉', '號': '号', '後': '后', '華': '华', '畫': '画',
          '歡': '欢', '黃': '黄', '會': '会', '活': '活', '火': '火',
          '幾': '几', '計': '计', '記': '记', '際': '际', '繼': '继',
          '家': '家', '價': '价', '減': '减', '見': '见', '將': '将',
          '講': '讲', '獎': '奖', '較': '较', '節': '节', '結': '结',
          '解': '解', '進': '进', '經': '经', '競': '竞', '舊': '旧',
          '開': '开', '間': '间', '減': '减', '見': '见', '將': '将',
          '講': '讲', '獎': '奖', '較': '较', '節': '节', '結': '结',
          '解': '解', '進': '进', '經': '经', '競': '竞', '舊': '旧',
          '開': '开', '間': '间'
        };
        
        let simplifiedText = text;
        for (const [traditional, simplified] of Object.entries(traditionalToSimplified)) {
          const regex = new RegExp(traditional, 'g');
          simplifiedText = simplifiedText.replace(regex, simplified);
        }
        
        return simplifiedText;
      };
      
      // 根据文件类型选择读取方式
      if (file.type === 'text/plain' || file.name.endsWith('.txt')) {
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (error) => reject(error);
        reader.readAsText(file);
      } else if (file.name.endsWith('.docx')) {
        // 使用mammoth库处理Word文档
        reader.onload = async (e) => {
          try {
            const arrayBuffer = e.target.result;
            
            // 设置mammoth选项，确保正确处理中文
            const options = {
              // 可以根据需要添加更多配置
            };
            
            const result = await mammoth.extractRawText({arrayBuffer: arrayBuffer}, options);
            
            // 提取的文本可能会有多余的空行，进行简单的清理
            let cleanText = result.value.replace(/\n\s+\n/g, '\n').trim();
            
            // 进行繁简转换，确保输出简体中文
            cleanText = convertToSimplified(cleanText);
            
            // 如果提取的内容不为空，则返回完整内容，否则返回提示信息
            if (cleanText.length > 0) {
              resolve(cleanText);
            } else {
              resolve(`Word文档 "${file.name}" 内容为空或无法提取。`);
            }
          } catch (error) {
            console.error('读取Word文档失败:', error);
            resolve(`读取Word文档 "${file.name}" 时出错。错误信息: ${error.message || '未知错误'}`);
          }
        };
        reader.onerror = (error) => {
          console.error('读取文件失败:', error);
          resolve(`读取Word文档 "${file.name}" 时出错。`);
        };
        reader.readAsArrayBuffer(file);
      } else if (file.name.endsWith('.pdf')) {
        // 对于PDF文件，使用FileReader读取为DataURL，然后在客户端处理
        reader.onload = (e) => {
          // 这里返回一个占位符文本，表示文件已上传，可以提问
          resolve(`PDF文档 "${file.name}" 已上传。您可以提问关于此文档的问题。`);
        };
        reader.onerror = (error) => {
          console.error('读取PDF文档失败:', error);
          resolve(`读取PDF文档 "${file.name}" 时出错。`);
        };
        reader.readAsDataURL(file);
      } else {
        // 对于其他不支持的文件类型，尝试以文本方式读取
        reader.onload = (e) => {
          resolve(`文件 "${file.name}" 已上传。`);
        };
        reader.onerror = (error) => {
          console.error('读取文件失败:', error);
          resolve(`读取文件 "${file.name}" 时出错。`);
        };
        reader.readAsText(file);
      }
    });
  };

  // 格式化Markdown文本的函数
  const formatText = (text) => {
    if (!text) return '';
    
    // 处理常见的Markdown格式
    let formatted = text
      // 处理#标题
      .replace(/#{6}\s+(.*?)$/gm, '<h6>$1</h6>')
      .replace(/#{5}\s+(.*?)$/gm, '<h5>$1</h5>')
      .replace(/#{4}\s+(.*?)$/gm, '<h4>$1</h4>')
      .replace(/#{3}\s+(.*?)$/gm, '<h3>$1</h3>')
      .replace(/#{2}\s+(.*?)$/gm, '<h2>$1</h2>')
      .replace(/#{1}\s+(.*?)$/gm, '<h1>$1</h1>')
      // 处理**粗体**和*斜体*
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      // 处理`代码`
      .replace(/`(.*?)`/g, '<code>$1</code>')
      // 处理换行
      .replace(/\n/g, '<br>');
      
    return formatted;
  };
  
  // 打字机效果函数
  const typeAnswer = (answer, index) => {
    setIsTyping(true);
    setCurrentAnswerIndex(index);
    setDisplayedAnswer('');
    
    let currentIndex = 0;
    const typeInterval = setInterval(() => {
      if (currentIndex < answer.length) {
        const nextChar = answer[currentIndex];
        setDisplayedAnswer(prev => prev + nextChar);
        
        // 同时更新对话历史中的displayedAnswer字段，确保实时同步显示
        setConversation(prev => {
          const newConversation = [...prev];
          if (newConversation[index]) {
            newConversation[index].displayedAnswer = prev[index].displayedAnswer + nextChar;
          }
          return newConversation;
        });
        
        currentIndex++;
      } else {
        clearInterval(typeInterval);
        setIsTyping(false);
        
        // 打字机效果完成后，更新localStorage中的对话历史
        const updatedConversation = [...conversation];
        updatedConversation[index].displayedAnswer = answer;
        setConversation(updatedConversation);
        localStorage.setItem('chatConversation', JSON.stringify(updatedConversation));
      }
    }, 10); // 每个字符之间的延迟（毫秒）- 增加到10毫秒以提高性能
  };

  const handleQuestionSubmit = async () => {
    if (!selectedFile || !question.trim()) {
      setError('请选择文件并输入问题');
      return;
    }

    setIsLoading(true);
    setError('');
    setAnswer('');
    setDisplayedAnswer('');
    setIsTyping(true);
    
    try {
      // 检查文件内容是否存在
      let fileContent = selectedFile.content;
      
      // 如果文件内容为空，尝试从服务器获取
      if (!fileContent || fileContent.trim() === '') {
        // 获取当前登录用户的用户名
        const token = localStorage.getItem('token');
        if (token && isLoggedIn && currentUser && currentUser.username) {
          const username = currentUser.username;
          const filename = selectedFile.name;
          
          try {
            // 从服务器获取文件内容
            const fileResponse = await fetch(`https://www.orient.icu/uploads/${username}/${encodeURIComponent(filename)}`);
            
            if (fileResponse.ok) {
              const contentType = fileResponse.headers.get('content-type');
              if (contentType && contentType.includes('application/json')) {
                const fileData = await fileResponse.json();
                fileContent = fileData.content || fileData || '';
              } else {
                fileContent = await fileResponse.text();
              }
              
              // 更新selectedFile中的文件内容
              if (fileContent && fileContent.trim()) {
                const updatedSelectedFile = {
                  ...selectedFile,
                  content: fileContent
                };
                setSelectedFile(updatedSelectedFile);
                
                // 同时更新files数组中的对应文件
                const updatedFiles = files.map(file => 
                  file.id === selectedFile.id ? { ...file, content: fileContent } : file
                );
                setFiles(updatedFiles);
              }
            } else {
              console.error('从服务器获取文件内容失败，状态码:', fileResponse.status);
            }
          } catch (error) {
            console.error('从服务器获取文件内容时发生错误:', error);
          }
        }
      }
      
      // 如果仍然没有文件内容，提示用户重新上传
      if (!fileContent || fileContent.trim() === '') {
        setError('文件内容不可用，请重新上传该文件后再提问');
        setIsLoading(false);
        setIsTyping(false);
        return;
      }
      
      // 准备发送到后端的数据
      const requestData = {
        query: question,
        chunks: [fileContent] // 将文件内容作为chunks发送
      };
      
      // 如果用户定义了角色，添加到请求数据中
      if (role && role.trim()) {
        requestData.role = role.trim();
      }
      
      // 添加新的对话项到对话历史（初始化空回答）
      const newConversationItem = {
        question: question,
        answer: '', // 初始为空，将通过流式响应填充
        file: selectedFile.name,
        timestamp: new Date().toLocaleString('zh-CN'),
        displayedAnswer: '' // 初始为空，将通过流式响应逐字填充
      };
      
      const newConversation = [...conversation, newConversationItem];
      setConversation(newConversation);
      
      // 清空输入框
      setQuestion('');

      // 获取token用于认证
      const token = localStorage.getItem('token');
      
      // 准备请求头
      const headers = {
        'Content-Type': 'application/json'
      };
      
      // 如果token存在，添加Authorization头
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      
      // 使用fetch API发送流式请求
      const response = await fetch('https://www.orient.icu/backend/stream', { 
        method: 'POST',
        headers: headers,
        body: JSON.stringify(requestData)
      });
      
      if (!response.ok) {
        throw new Error('获取回答失败');
      }
      
      // 处理流式响应
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let fullAnswer = '';
      let buffer = '';
      let conversationIndex = newConversation.length - 1;
      
      try {
        while (true) {
          const { done, value } = await reader.read();
          
          if (done) {
            break;
          }
          
          // 解码数据
          buffer += decoder.decode(value, { stream: true });
          
          // 处理SSE格式的数据
          let boundaryIndex;
          while ((boundaryIndex = buffer.indexOf('\n\n')) >= 0) {
            const line = buffer.substring(0, boundaryIndex).trim();
            buffer = buffer.substring(boundaryIndex + 2);
            
            if (line.startsWith('data:')) {
              const dataStr = line.substring(5).trim();
              
              try {
                const data = JSON.parse(dataStr);
                
                // 处理错误信息
                if (data.error) {
                  setError(data.error);
                  setIsTyping(false);
                  setIsLoading(false); // 重置加载状态
                  break;
                }
                
                // 处理完成标志
                if (data.finished) {
                  // 保存完整回答 - 创建fullAnswer的副本以避免闭包问题
                  const finalFullAnswer = fullAnswer;
                  setConversation(prevConversation => {
                    const updatedConversation = [...prevConversation];
                    updatedConversation[conversationIndex] = {
                      ...updatedConversation[conversationIndex],
                      answer: finalFullAnswer,
                      displayedAnswer: finalFullAnswer // 同时更新displayedAnswer字段
                    };
                    // 保存到localStorage
                    localStorage.setItem('chatConversation', JSON.stringify(updatedConversation));
                    return updatedConversation;
                  });
                  setIsTyping(false);
                  setIsLoading(false); // 重置加载状态
                  break;
                }

                // 处理内容块
                if (data.content) {
                  fullAnswer += data.content;
                  const currentFullAnswer = fullAnswer; // 创建当前值的副本
                  
                  // 更新显示的回答（打字机效果）
                  setDisplayedAnswer(currentFullAnswer);
                  
                  // 同时更新对话历史中的displayedAnswer字段
                  setConversation(prev => {
                    const updated = [...prev];
                    if (updated[conversationIndex]) {
                      updated[conversationIndex].displayedAnswer = currentFullAnswer;
                    }
                    return updated;
                  });
                  
                  // 实时保存对话历史到localStorage - 使用IIFE来捕获当前值
                  ((savedAnswer) => {
                    setTimeout(() => {
                      setConversation(prev => {
                        const updated = [...prev];
                        if (updated[conversationIndex]) {
                          updated[conversationIndex].displayedAnswer = savedAnswer;
                        }
                        localStorage.setItem('chatConversation', JSON.stringify(updated));
                        return updated;
                      });
                    }, 0);
                  })(currentFullAnswer);
                }
              } catch (error) {
                console.error('解析响应数据错误:', error);
                setIsLoading(false); // 重置加载状态
                break;
              }
            }
          }
        }
      } finally {
        // 确保在函数结束时重置加载状态
        setIsTyping(false);
        setIsLoading(false); // 重置加载状态
      }
    } catch (error) {
      console.error('提问失败:', error);
      setError('提问失败，请稍后重试');
      setIsTyping(false);
    }
  };

  // 移除全局的EventSource实例，因为它已经被集成到handleQuestionSubmit函数中
  
  const handleDeleteFile = async (fileId) => {
    try {
      // 查找要删除的文件对象
      const fileToDelete = files.find(file => file.id === fileId);
      if (!fileToDelete) {
        console.error('未找到要删除的文件');
        return;
      }
      
      // 获取认证token
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('未找到认证token');
        return;
      }
      
      // 调用后端API删除文件
      const response = await fetch(`https://www.orient.icu/backend/files/${encodeURIComponent(fileToDelete.name)}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error('删除文件失败');
      }
      
      // 更新前端状态
      setFiles(files.filter(file => file.id !== fileId));
      if (selectedFile && selectedFile.id === fileId) {
        setSelectedFile(null);
      }
      if (answer) {
        setAnswer(''); // 如果删除了当前正在使用的文件，清除回答
      }
      
      // 更新localStorage中的文件列表
      const updatedFiles = files.filter(file => file.id !== fileId);
      localStorage.setItem('chatFiles', JSON.stringify(updatedFiles.map(file => ({
        id: file.id,
        name: file.name,
        content: file.content
      }))));
      
    } catch (err) {
      console.error('删除文件时出错:', err);
      setError('删除文件失败，请重试');
    }
  };

  // 生成代码的函数
  const handleGenerateCode = async () => {
    if (!currentUser) {
      setError('请先登录');
      return;
    }
    
    if (!deploymentMethod || !modelType || !role) {
      setError('请先填写完整的部署信息');
      return;
    }

        // 微信公众号部署的特殊验证
    if (deploymentMethod === '微信公众号') {
      if (!wechatAppId || !wechatAppSecret) {
        setError('微信公众号部署需要填写原始ID和AppSecret');
        return;
      }
      
      // 显示IP白名单提示
      alert(`请将服务器IP地址 47.76.62.49 添加到微信公众号的IP白名单中`);
    }


    // 生成一个API密钥
    const apiKey = `sk-${currentUser.username}-${Math.random().toString(36).substr(2, 8)}`;
    const token = localStorage.getItem('token');
    
    // 根据部署方式生成不同的代码
    let scriptCode = '';
    if (deploymentMethod === '微信公众号') {
    // 微信公众号部署生成三个可复制对象
      scriptCode = `URL: https://www.orient.icu/wx\nToken: dralch3104\nEncodingAESKey: D5nAdNoDXC9MOZ8zA1FAKWzFIDG87NG0rmzNIhL1ZOT`;
    } else {
    // 其他部署方式生成script标签代码
      scriptCode = `<script src="https://www.orient.icu/uploads/simple-chat-widget.js" data-user="${currentUser.username}" data-api-key="${apiKey}" data-role="${role}" data-files="${associatedFiles || ''}" data-token="${localStorage.getItem('token') || ''}"></script>`;
    }

    // 检查是否已经存在微信公众号部署
    let updatedApis;
    let apiToUpdate = null;
    
    // 只对微信公众号部署进行唯一性检查
    if (deploymentMethod === '微信公众号') {
      // 查找现有的微信公众号部署
      apiToUpdate = apis.find(api => api.deploymentMethod === '微信公众号');
    }
    
    if (apiToUpdate) {
      // 如果存在微信公众号部署，则更新它
      const updatedApi = {
        ...apiToUpdate,
        modelType,
        role,
        associatedFiles: associatedFiles ? associatedFiles.split(', ').filter(f => f.trim()) : [],
        updatedAt: new Date().toLocaleString('zh-CN'),
        scriptCode: scriptCode
      };
      
      // 更新API列表
      updatedApis = apis.map(api => 
        api.id === apiToUpdate.id ? updatedApi : api
      );
      
      // 使用相同的API key进行后端同步
      apiKey = apiToUpdate.key;
      
      // 提示用户已更新部署
      alert('已更新您的微信公众号部署配置');
    } else {
      // 如果不存在，则创建新的API对象
      const newApi = {
        id: Date.now(),
        key: apiKey,
        deploymentMethod,
        modelType,
        role,
        associatedFiles: associatedFiles ? associatedFiles.split(', ').filter(f => f.trim()) : [],
        createdAt: new Date().toLocaleString('zh-CN'),
        scriptCode: scriptCode
      };

      // 更新API列表
      updatedApis = [newApi, ...apis];
    }
    
    setApis(updatedApis);
    
    // 保存到localStorage
    localStorage.setItem('deployments', JSON.stringify(updatedApis));
    
    // 同步API配置到后端服务器
    try {
      const response = await fetch('https://www.orient.icu/backend/code-generation/params', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          key: apiKey,
          deployment: deploymentMethod,
          model: modelType,
          role: role,
          associatefiles: associatedFiles ? associatedFiles.split(', ').filter(f => f.trim()) : [],
          path: '' // 添加path参数，即使为空字符串也需要传递
        })
      });
      
      if (!response.ok) {
        throw new Error('同步API配置到后端失败');
      }
    } catch (error) {
      console.error('同步API配置时出错:', error);
    }
    setError('');
  };

  // 删除部署代码的函数
  const handleDeleteApi = async (apiId) => {
    const apiToDelete = apis.find(api => api.id === apiId);
    if (!apiToDelete) {
      console.error('未找到要删除的API配置');
      return;
    }

    // 调用后端API删除参数
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('未找到认证token');
      } else {
        const response = await fetch('https://www.orient.icu/backend/code-generation/params', {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            key: apiToDelete.key
          })
        });
        
        if (!response.ok) {
          throw new Error('删除后端参数失败');
        }
      }
    } catch (error) {
      console.error('删除后端参数时出错:', error);
    }

    // 删除前端数据
    const updatedApis = apis.filter(api => api.id !== apiId);
    setApis(updatedApis);
    // 更新localStorage
    localStorage.setItem('deployments', JSON.stringify(updatedApis));
  };

  const handlePageChange = (page) => {
    setActivePage(page);
  };

  // 辅助函数：格式化文件大小
  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + 'B';
    else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + 'KB';
    else return (bytes / 1048576).toFixed(1) + 'MB';
  };

  return (
    <div className="app-container">
      <header className="app-header">
        <div className="header-content">
          <h1 className="app-title">Chat For You</h1>
          <nav className="app-nav">
            <button
              className={`nav-button ${activePage === 'home' ? 'active' : ''}`}
              onClick={() => handlePageChange('home')}
            >
              主页
            </button>
            <button
              className={`nav-button ${activePage === 'admin' ? 'active' : ''}`}
              onClick={() => handlePageChange('admin')}
            >
              管理中心
            </button>
          </nav>
          {isLoggedIn ? (
            <div className="auth-controls">
              <div className="user-profile" onClick={() => handlePageChange('account')}>
                <div className="avatar">
                  {currentUser?.username?.charAt(0).toUpperCase() || 'U'}
                </div>
                <span className="username">{currentUser?.username}</span>
              </div>
              <button 
                className="logout-btn"
                onClick={handleLogout}
              >
                退出登录
              </button>
            </div>
          ) : (
            <button 
              className="login-btn"
              onClick={() => setShowAuthModal(true)}
            >
              登录/注册
            </button>
          )}
        </div>
      </header>

      {showAuthModal && (
        <div className="modal-overlay" onClick={() => setShowAuthModal(false)}>
          <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{showLoginForm ? '用户登录' : '用户注册'}</h2>
              <button className="close-btn" onClick={() => setShowAuthModal(false)}>
                ×
              </button>
            </div>
            {showLoginForm ? (
              <form className="auth-form" onSubmit={handleLogin}>
                <div className="form-group">
                  <label htmlFor="loginUsername">用户名</label>
                  <input
                    type="text"
                    id="loginUsername"
                    value={loginUsername}
                    onChange={(e) => setLoginUsername(e.target.value)}
                    placeholder="请输入用户名"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="loginPassword">密码</label>
                  <input
                    type="password"
                    id="loginPassword"
                    value={loginPassword}
                    onChange={(e) => setLoginPassword(e.target.value)}
                    placeholder="请输入密码"
                    required
                  />
                </div>
                {authError && (
                  <div className="auth-error">{authError}</div>
                )}
                <button type="submit" className="submit-btn" disabled={isLoading}>
                  {isLoading ? '登录中...' : '登录'}
                </button>
                <button type="button" className="switch-form-btn" onClick={() => setShowLoginForm(false)}>
                  没有账号？立即注册
                </button>
              </form>
            ) : (
              <form className="auth-form" onSubmit={handleRegister}>
                <div className="form-group">
                  <label htmlFor="registerUsername">用户名</label>
                  <input
                    type="text"
                    id="registerUsername"
                    value={registerUsername}
                    onChange={(e) => setRegisterUsername(e.target.value)}
                    placeholder="请输入用户名"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="registerPassword">密码</label>
                  <input
                    type="password"
                    id="registerPassword"
                    value={registerPassword}
                    onChange={(e) => setRegisterPassword(e.target.value)}
                    placeholder="请设置密码"
                    required
                  />
                </div>
                {authError && (
                  <div className="auth-error">{authError}</div>
                )}
                <button type="submit" className="submit-btn" disabled={isLoading}>
                  {isLoading ? '注册中...' : '注册'}
                </button>
                <button type="button" className="switch-form-btn" onClick={() => setShowLoginForm(true)}>
                  已有账号？返回登录
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      <main className="app-main">
        {/* 未登录时显示的提示信息 */}
        {!isLoggedIn ? (
          <div className="login-prompt">
            <div className="prompt-content">
              <h2>欢迎使用 Chat For You</h2>
              <p>请先登录或注册以使用完整功能</p>
              <button 
                className="prompt-login-btn" 
                onClick={() => setShowAuthModal(true)}
              >
                立即登录/注册
              </button>
            </div>
          </div>
        ) : (
          // 登录后显示应用内容
          <>
            {activePage === 'home' ? (
              <div className="home-layout">
                <section className="upload-section">
                  <h2>上传文档</h2>
                  <div className="upload-area">
                    <button className="upload-btn" onClick={handleUploadClick}>
                      <div className="upload-icon">📄</div>
                      <p>点击选择文件</p>
                      <p className="upload-hint">支持 TXT、DOCX 格式</p>
                    </button>
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileSelect}
                      className="file-input"
                      accept=".txt,.docx"
                      multiple
                      style={{ display: 'none' }}
                    />
                  </div>
                  
                  {filesToUpload.length > 0 && (
                    <div className="selected-files">
                      <h4>已选择 {filesToUpload.length} 个文件</h4>
                      <ul className="selected-files-list">
                        {filesToUpload.map((file, index) => (
                          <li key={index}>{file.name}</li>
                        ))}
                      </ul>
                      <button 
                        className="confirm-upload-btn"
                        onClick={handleConfirmUpload}
                        disabled={isLoading}
                      >
                        {isLoading ? '上传中...' : '确认上传'}
                      </button>
                    </div>
                  )}

                  <div className="recent-files">
                    <h3>已上传文件</h3>
                    {files.length > 0 ? (
                      <ul className="file-list">
                        {files.map(file => (
                          <li key={file.id} className="file-item">
                            <div className="file-info">
                        <span className="file-name"><strong>{file.name}</strong></span>
                        <span className="file-size">{file.size}</span>
                        <span className="file-date">{file.uploadedAt}</span>
                      </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="no-files">暂无上传的文件</p>
                    )}
                  </div>
                </section>

                <section className="qa-section">
                  <h2>提问与回答</h2>
                  
                  <div className="qa-container">
                    {conversation.length > 0 ? (
                      <div className="conversation-container" ref={conversationContainerRef}>
                        {conversation.map((item, index) => (
                          <div key={index} className="conversation-item">
                        <div className="question-bubble">
                          <strong>Q:</strong> {item.question}
                        </div>
                        <div className="answer-bubble">
                          <strong>A:</strong>
                          <span dangerouslySetInnerHTML={{ __html: formatText(index === currentAnswerIndex ? displayedAnswer : item.displayedAnswer) }} />
                          {index === currentAnswerIndex && isTyping && (
                            <span className="typing-cursor">|</span>
                          )}
                        </div>
                      </div>
                        ))}
                      </div>
                    ) : (
                      <div className="welcome-message">
                        <p>欢迎使用个人知识问答系统！</p>
                        <p>请先上传文档，然后选择文件并输入问题获取基于文档内容的回答。</p>
                      </div>
                    )}
                  </div>

                  <div className="question-input-container">
                    <select 
                      className="file-selector"
                      value={selectedFile ? selectedFile.id : ''}
                      onChange={(e) => {
                        const file = files.find(f => f.id === e.target.value);
                        if (file) setSelectedFile(file);
                      }}
                    >
                      <option value="">选择文件</option>
                      {files.map(file => (
                        <option key={file.id} value={file.id}>{file.name}</option>
                      ))}
                    </select>
                    <input
                      type="text"
                      className="question-input"
                      placeholder="请输入您的问题..."
                      value={question}
                      onChange={(e) => setQuestion(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && handleQuestionSubmit()}
                    />
                    <button 
                      className="submit-button"
                      onClick={handleQuestionSubmit}
                      disabled={isLoading || !selectedFile || !question.trim()}
                    >
                      提问
                    </button>
                     <button 
                      className="clear-button"
                      onClick={handleClearConversation}
                      disabled={isLoading || conversation.length === 0}
                    >
                      清空
                    </button>
                   
                  </div>
                  
                  {error && (
                    <div className="error-message">
                      {typeof error === 'string' ? error : JSON.stringify(error)}
                    </div>
                  )}
                </section>
              </div>
            ) : activePage === 'account' ? (
              <div className="account-layout">
                <section className="account-info">
                  <h2>账号信息</h2>
                  <div className="account-details">
                    <div className="account-avatar">
                      {currentUser?.username?.charAt(0).toUpperCase() || 'U'}
                    </div>
                    <div className="account-fields">
                      <div className="field-group">
                        <label>用户名:</label>
                        <span>{currentUser?.username}</span>
                      </div>
                      <div className="field-group">
                        <label>Score:</label>
                        <span>{currentUser?.score || 0}</span>
                      </div>
                      <div className="recharge-section">
                        <button className="recharge-button" onClick={() => showRechargeModal()}>充值Score</button>
                      </div>
                    </div>
                  </div>
                </section>
                
                <section className="account-settings">
                  <h3>账号设置</h3>
                  <div className="settings-form">
                    <div className="form-group">
                      <label>修改密码</label>
                      <button className="change-password-btn" onClick={handleChangePassword}>
                        修改密码
                      </button>
                    </div>
                    <div className="form-group">
                      <label>绑定原始ID</label>
                      <button className="bind-appid-btn" onClick={handleBindAppid}>
                        {appid ? `已绑定: ${appid.substring(0, 6)}...` : '绑定原始ID'}
                      </button>
                    </div>
                  </div>
                </section>
                
                <section className="usage-stats">
                  <h3>使用统计</h3>
                  <div className="stats-grid">
                    <div className="stat-item">
                      <span className="stat-label">已上传文件</span>
                      <span className="stat-value">{files.length}</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-label">对话次数</span>
                      <span className="stat-value">{conversation.length}</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-label">部署数量</span>
                      <span className="stat-value">{apis.length}</span>
                    </div>
                  </div>
                </section>
              </div>
            ) : (
              <div className="admin-container">
                <h2>管理中心</h2>
                <div className="home-layout admin-layout">
                  <section className="file-management">
                    <h3>文件管理</h3>
                    <button className="upload-btn" onClick={() => setActivePage('home')}>
                      上传新文件
                    </button>
                    <div className="uploaded-files">
                      <h4>已上传的文件</h4>
                      {files.length > 0 ? (
                        <ul className="file-list">
                          {files.map(file => (
                            <li key={file.id} className="file-item">
                              <div className="file-info">
                                <span className="file-name"><strong>{file.name}</strong></span>
                                <span className="file-size">{file.size}</span>
                                <span className="file-date">{file.uploadedAt}</span>
                              </div>
                              <button
                                className="delete-button"
                                onClick={() => handleDeleteFile(file.id)}
                              >
                                删除
                              </button>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="no-files">暂无上传的文件</p>
                      )}
                    </div>
                    
                    {/* 部署管理板块 */}
                    <div className="deployment-management">
                      <h4>部署管理</h4>
                      <div className='api-list-container'>
                      {apis.length > 0 ? (
                        <ul className="api-list">
                          {apis.map(api => (
                            <li key={api.id} className="api-item">
                              <div className="api-info">
                                <span className="api-key">{api.key}</span>
                                <div className="api-details">
                                  <span className="api-method">{api.deploymentMethod}</span>
                                  <span className="api-model">{api.modelType}</span>
                                  {api.associatedFiles && (
                                    <span className="api-knowledge">
                                      知识库: {api.associatedFiles.join(', ')}
                                    </span>
                                  )}
                                  <button
                                    className="copy-button"
                                    onClick={(event) => {
                                      navigator.clipboard.writeText(api.scriptCode);
                                      // 显示复制成功的提示
                                      const btn = event.target;
                                      const originalText = btn.textContent;
                                      btn.textContent = '已复制！';
                                      setTimeout(() => {
                                        btn.textContent = originalText;
                                      }, 2000);
                                    }}
                                  >
                                    复制嵌入代码
                                  </button>
                                </div>
                              </div>
                              <button
                                className="delete-button"
                                onClick={() => handleDeleteApi(api.id)}
                              >
                                删除
                              </button>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="no-apis">暂无部署代码，请在部署管理中生成</p>
                      )}
                      </div>
                    </div>
                  </section>

                  <section className="model-management qa-section">
                    <h3>管理部署</h3>
                    <div className="model-settings">
                      <div className="setting-item">
                        <label>部署详情：</label>
                        <select 
                          className="setting-select"
                          value={deploymentMethod}
                          onChange={(e) => setDeploymentMethod(e.target.value)}
                        >
                          <option value="">选择部署方式</option>
                          <option value="嵌入网站">嵌入网站</option>
                          <option value="微信公众号">微信公众号</option>
                          {/* <option value="微信小程序">微信小程序</option>
                          <option value="微信客服">微信客服</option>
                          <option value="WebAPP">WebAPP</option> */}
                        </select>
                      </div>
                      <div className="setting-item">
                        <label>模型选择：</label>
                        <select 
                          className="setting-select"
                          value={modelType}
                          onChange={(e) => setModelType(e.target.value)}
                        >
                          <option value="">选择模型类型</option>
                          <option value="chatgpt-5">chatgpt-5</option>
                          <option value="deepseek-r1">deepseek-r1</option>
                        </select>
                      </div>
                      <div className="setting-item">
                        <label>角色：</label>
                        <input 
                          type="text" 
                          className="setting-input"
                          placeholder="请输入角色名称（例如：你是一位房地产客服）"
                          value={role}
                          onChange={(e) => setRole(e.target.value)}
                        />
                      </div>
                      <div className="setting-item">
                        <label>关联文件：</label>
                        <div className="file-selector-container">
                          <button 
                            className="file-selector-btn"
                            onClick={() => setShowFileDropdown(!showFileDropdown)}
                            type="button"
                          >
                            {associatedFiles ? `已选择 ${associatedFiles.split(', ').filter(f => f.trim()).length} 个文件` : '选择关联文件'}
                            <span className="dropdown-arrow">▼</span>
                          </button>
                          
                          {showFileDropdown && (
                            <div className="file-dropdown">
                              <div className="file-dropdown-header">
                                <span>选择文件</span>
                                <button 
                                  className="close-dropdown"
                                  onClick={() => setShowFileDropdown(false)}
                                >
                                  ×
                                </button>
                              </div>
                              <div className="file-list-container">
                                {files.length > 0 ? (
                                  files.map(file => {
                                    const isSelected = associatedFiles && associatedFiles.split(', ').includes(file.name);
                                    return (
                                      <label key={file.id} className="file-option">
                                        <input
                                          type="checkbox"
                                          checked={isSelected}
                                          onChange={(e) => {
                                            const selectedFiles = associatedFiles ? associatedFiles.split(', ').filter(f => f.trim()) : [];
                                            if (e.target.checked) {
                                              // 添加文件
                                              if (!selectedFiles.includes(file.name)) {
                                                selectedFiles.push(file.name);
                                              }
                                            } else {
                                              // 移除文件
                                              const index = selectedFiles.indexOf(file.name);
                                              if (index > -1) {
                                                selectedFiles.splice(index, 1);
                                              }
                                            }
                                            setAssociatedFiles(selectedFiles.join(', '));
                                          }}
                                        />
                                        <span className="checkbox-custom"></span>
                                        <span className="file-name">{file.name}</span>
                                        <span className="file-size">{file.size}</span>
                                      </label>
                                    );
                                  })
                                ) : (
                                  <div className="no-files-message">暂无上传的文件</div>
                                )}
                              </div>
                              <div className="file-dropdown-footer">
                                <button 
                                  className="confirm-selection"
                                  onClick={() => setShowFileDropdown(false)}
                                >
                                  确认选择
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                        {associatedFiles && (
                          <div className="selected-files-preview">
                            <small>已选择文件：{associatedFiles}</small>
                          </div>
                        )}
                      </div>

                      {/* 微信公众号特定配置 */}
                      {deploymentMethod === '微信公众号' && (
                        <>
                          <div className="setting-item">
                            <label>原始ID：</label>
                            <input 
                              type="text" 
                              className="setting-input"
                              placeholder="请输入微信公众号原始ID"
                              value={wechatAppId}
                              onChange={(e) => setWechatAppId(e.target.value)}
                            />
                          </div>
                          <div className="setting-item">
                            <label>AppSecret：</label>
                            <input 
                              type="password" 
                              className="setting-input"
                              placeholder="请输入微信公众号AppSecret"
                              value={wechatAppSecret}
                              onChange={(e) => setWechatAppSecret(e.target.value)}
                            />
                          </div>
                          <div className="setting-item">
                            <div className="wechat-tip">
                              <strong>重要提示：</strong>请将服务器IP地址 <code>47.76.62.49</code> 添加到微信公众号的IP白名单中
                            </div>
                          </div>
                        </>
                      )}

                      <button 
                        className="generate-api-btn"
                        onClick={handleGenerateCode}
                      >
                        生成代码
                      </button>
                    </div>
                  </section>
                </div>
              </div>
            )}
          </>
        )}
      </main>
    </div>
  );
}

export default App;
